import { motion } from "framer-motion";
import { ReactNode } from "react";

export const FloatY = ({
  children,
  className = "",
  amplitude = 14,
  duration = 7,
  direction = "up",
  delay = 0,
}: {
  children: ReactNode;
  className?: string;
  amplitude?: number;
  duration?: number;
  direction?: "up" | "down";
  delay?: number;
}) => {
  const sign = direction === "up" ? -1 : 1;

  return (
    <motion.div
      className={className}
      animate={{ y: [0, sign * amplitude, 0] }}
      transition={{
        duration,
        delay,
        repeat: Infinity,
        repeatType: "loop",
        ease: "easeInOut",
      }}
    >
      {children}
    </motion.div>
  );
};
